var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ib-button',{attrs:{"disabled":!_vm.canEdit,"font-family":"regular"},on:{"click":_vm.onClick}},[_c('i',{staticClass:"icon ib-icon ib-icon-plus-math mr-1"}),_c('span',{staticClass:"font-outfit-regular"},[_vm._v(_vm._s(_vm.$t('add')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }